'use strict';
import * as $j_app$002eapi$002e$002dUsers$002dEdit$002dRequest from "./app.api.-Users-Edit-Request.js";
import * as $j_app$002edata$002e$002dOrganization$002dName$0024package$0024$002dOrganization$002dName$002dForm$0024 from "./app.data.-Organization-Name$package$-Organization-Name-Form$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$002dForm$0024 from "./app.data.-User-Details-Form$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_UsersEditRequestForm$$anon$5() {
}
export { $c_Lapp_api_UsersEditRequestForm$$anon$5 as $c_Lapp_api_UsersEditRequestForm$$anon$5 };
$p = $c_Lapp_api_UsersEditRequestForm$$anon$5.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_UsersEditRequestForm$$anon$5;
/** @constructor */
function $h_Lapp_api_UsersEditRequestForm$$anon$5() {
}
export { $h_Lapp_api_UsersEditRequestForm$$anon$5 as $h_Lapp_api_UsersEditRequestForm$$anon$5 };
$h_Lapp_api_UsersEditRequestForm$$anon$5.prototype = $p;
$p.bYv = (function(src, failFast) {
  var this$1 = $j_app$002edata$002e$002dUser$002dDetails$002dForm$0024.$m_Lapp_data_UserDetailsForm$().bsa().bh(src.Bn, failFast);
  matchResult12: {
    var resultA;
    if ((this$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
      var resultA = this$1;
      break matchResult12;
    }
    if ((this$1 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors)) {
      var resultA = this$1.bo(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_PathElement$Accessor("user"));
      break matchResult12;
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$1);
  }
  var f = (() => {
    var this$3 = src.Bm;
    if (this$3.c()) {
      var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
    } else {
      var arg1 = this$3.g();
      var this$6 = $j_app$002edata$002e$002dOrganization$002dName$0024package$0024$002dOrganization$002dName$002dForm$0024.$m_Lapp_data_OrganizationName$package$OrganizationNameForm$().az().bh(arg1, failFast);
      matchResult7: {
        var $x_1;
        if ((this$6 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
          var $x_1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Option$().as(this$6.a1));
          break matchResult7;
        }
        if ((this$6 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors)) {
          var $x_1 = this$6;
          break matchResult7;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$6);
      }
    }
    var this$9 = $x_1;
    if ((this$9 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
      return this$9;
    }
    if ((this$9 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors)) {
      return this$9.bo(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_PathElement$Accessor("organization"));
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this$9);
  });
  var f$1 = ((param, param2) => new $j_app$002eapi$002e$002dUsers$002dEdit$002dRequest.$c_Lapp_api_UsersEditRequest(param, param2));
  if (failFast) {
    matchResult29: {
      var $x_2;
      if ((resultA instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
        var x114 = resultA.a1;
        var x101 = f();
        if ((x101 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
          var x107 = x101.a1;
          var $x_2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value(f$1(x114, x107));
          break matchResult29;
        }
        if ((x101 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors)) {
          var $x_2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors(x101.f0);
          break matchResult29;
        }
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x101);
      }
      if ((resultA instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors)) {
        var $x_2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors(resultA.f0);
        break matchResult29;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(resultA);
    }
    return $x_2;
  } else {
    matchResult30: {
      var $x_3;
      var x115 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), resultA, f());
      var x132 = x115.hT;
      var x133 = x115.hE;
      if ((x132 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
        var x139 = x132.a1;
        if ((x133 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
          var x136 = x133.a1;
          var $x_3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value(f$1(x139, x136));
          break matchResult30;
        }
      }
      if ((x132 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors)) {
        var x131 = x132.f0;
        if ((x133 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors)) {
          var $x_3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_internal_runtime_NonEmptyErrorsChain$Merge(x131, x133.f0));
          break matchResult30;
        }
        if ((x133 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value)) {
          var $x_3 = x132;
          break matchResult30;
        }
      }
      if (((x132 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Value) && (x133 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_scalaland_chimney_partial_Result$Errors))) {
        var $x_3 = x133;
        break matchResult30;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x115);
    }
    return $x_3;
  }
});
$p.bh = (function(src, failFast) {
  return this.bYv(src, failFast);
});
var $d_Lapp_api_UsersEditRequestForm$$anon$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_UsersEditRequestForm$$anon$5, "app.api.UsersEditRequestForm$$anon$5", ({
  yN: 1,
  bz: 1,
  by: 1
}));
export { $d_Lapp_api_UsersEditRequestForm$$anon$5 as $d_Lapp_api_UsersEditRequestForm$$anon$5 };
//# sourceMappingURL=app.api.-Users-Edit-Request-Form$$anon$5.js.map
